import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function ApiResult({ errorObject }: {
    errorObject:
    null | any
}) {

    return (
        <div>
            {
                errorObject && errorObject.message ?
                    <div className={"alert alert-" + (errorObject.status ? 'success' : 'danger')} role="alert">
                        <FontAwesomeIcon icon={["fas", (errorObject.status ? "check" : "exclamation-triangle")]} /> {errorObject.message}
                    </div>
                    : errorObject && errorObject.errors ?
                        <>
                            {
                                errorObject.errors.map((error: any) => {
                                    return (
                                        <div className={"alert alert-" + (error.status ? 'success' : 'danger')} role="alert">
                                            <FontAwesomeIcon icon={["fas", (error.status ? "check" : "exclamation-triangle")]} /> <strong>{error.name ? error.name : error.key}</strong> {error.message}
                                        </div>
                                    )
                                })
                            }
                        </>
                        : null
            }
        </div>
    )
}

export default ApiResult;
